module.exports = __webpack_public_path__ + "img/03-min.34e1aef0.jpg";